export default __webpack_public_path__ + "static/social-image-c8e5f33e971fc38a9de2459c590fe669.png";